export function getRequiredLocalStorageString(key: string) {
  const value = getLocalStorageString(key);

  if (!value) {
    throw new Error(`Missing required item: ${key}`);
  }

  return value;
}

export function getLocalStorageString(key: string) {
  return localStorage.getItem(key);
}

export function setLocalStorageString(key: string, value: string) {
  return localStorage.setItem(key, value);
}